import { Country } from 'react-phone-number-input';

const COUNTRIES: Country[] = ['US', 'CA'];

export default COUNTRIES;
